module.exports = __webpack_public_path__ + "img/bh.86725006.svg";